import React, { useState } from "react";
import styled from "styled-components";
import { TitleText, LabelText } from "../../../../ui/Text";
import { Field, FieldArray, FormikProps } from "formik";
import Input from "../../../../ui/Input";
import { Button } from "../../../../ui/Button";
import { CloseIcon2 } from "../../../../assets/svg/CloseIcon2";
import { get } from "../../../../utils/get";
import { is360Subject } from "../../../../subjects/Is360Subject";

interface InitialVals {
  questions: any[];
  prompt: string;
  answer1?: string;
  answer2?: string;
  answer3?: string;
  answer4?: string;
  answer5?: string;
}

export const KPIQuestions = ({
  formikBag,
}: {
  formikBag: FormikProps<InitialVals>;
}) => {
  const { values, setValues, setFieldValue } = formikBag;
  const [hover, setHover] = useState(0);
  const [isEdit, setIsEdit] = useState({
    isEdit: false,
    editIndex: 0,
    editData: {},
  });
  return (
    <FieldArray
      name="questions"
      render={(arrayHelpers) => (
        <Container>
          <PromptContainer>
            <LabelText>Prompt</LabelText>
            <div style={{ marginTop: "1em" }}>
              {values.questions.map((question, index) => (
                <React.Fragment key={index}>
                  <AddedPrompt
                    isHover={hover === index + 1}
                    onMouseEnter={() => setHover(index + 1)}
                    onMouseLeave={() => setHover(0)}
                  >
                    {index + 1 !== isEdit.editIndex && (
                      <>
                        <TitleText
                          onClick={() => {
                            setIsEdit({
                              isEdit: true,
                              editIndex: index + 1,
                              editData: question,
                            });
                            setFieldValue(
                              `prompt${index + 1}`,
                              `${question.prompt}`
                            );
                            setFieldValue(
                              "answer1",
                              get(question, "answer1", "")
                            );
                            setFieldValue(
                              "answer2",
                              get(question, "answer2", "")
                            );
                            setFieldValue(
                              "answer3",
                              get(question, "answer3", "")
                            );
                            setFieldValue(
                              "answer4",
                              get(question, "answer4", "")
                            );
                            setFieldValue(
                              "answer5",
                              get(question, "answer5", "")
                            );
                          }}
                        >
                          {question.prompt}
                        </TitleText>
                        {hover === index + 1 && !isEdit.isEdit && (
                          <CloseIcon2
                            onClick={() => arrayHelpers.remove(index)}
                            strokeColor="#a6b3bf"
                            width={20}
                            height={20}
                          />
                        )}
                      </>
                    )}
                  </AddedPrompt>
                  {isEdit.isEdit && index + 1 === isEdit.editIndex && (
                    <>
                      <Field
                        name={`prompt${index + 1}`}
                        type="textarea"
                        component={Input}
                        width="80%"
                      />
                      <Button
                        text="Cancel"
                        backgroundColor="#fff"
                        color="#000"
                        onClick={() => {
                          setIsEdit({
                            isEdit: false,
                            editIndex: 0,
                            editData: {},
                          });
                          setFieldValue("prompt", "");
                          setFieldValue("answer1", "");
                          setFieldValue("answer2", "");
                          setFieldValue("answer3", "");
                          setFieldValue("answer4", "");
                          setFieldValue("answer5", "");
                        }}
                      />
                      <Button
                        text="Update"
                        onClick={() => {
                          let question = {
                            prompt: get(values, `prompt${index + 1}`, ""),
                            answer1: values.answer1,
                            answer2: values.answer2,
                            answer3: values.answer3,
                            answer4: values.answer4,
                            answer5: values.answer5,
                          };
                          arrayHelpers.replace(index, question);
                          setIsEdit({
                            isEdit: false,
                            editIndex: 0,
                            editData: {},
                          });
                          setFieldValue("prompt", "");
                          setFieldValue("answer1", "");
                          setFieldValue("answer2", "");
                          setFieldValue("answer3", "");
                          setFieldValue("answer4", "");
                          setFieldValue("answer5", "");
                        }}
                      />
                    </>
                  )}
                </React.Fragment>
              ))}
              {!isEdit.isEdit && (
                <>
                  <Field
                    name={`prompt`}
                    component={Input}
                    type="textarea"
                    width="87%"
                  />
                  <Button
                    text="Add New +"
                    onClick={() => {
                      let question = {
                        prompt: values.prompt,
                        answer1: values.answer1,
                        answer2: values.answer2,
                        answer3: values.answer3,
                        answer4: values.answer4,
                        answer5: values.answer5,
                      };
                      arrayHelpers.push(question);
                      setFieldValue("prompt", "");
                      setFieldValue("answer1", "");
                      setFieldValue("answer2", "");
                      setFieldValue("answer3", "");
                      setFieldValue("answer4", "");
                      setFieldValue("answer5", "");
                    }}
                    style={{
                      marginTop: "2em",
                      marginRight: "2em",
                      float: "right",
                    }}
                  />
                </>
              )}
            </div>
          </PromptContainer>
          <AnswerContainer>
            <LabelText>Answers</LabelText>
            <div
              style={{
                marginTop: "1em",
              }}
            >
              <Field name="answer1" component={Input} color="#e7221f" />
              <Field name="answer2" component={Input} color="#e82e2e" />
              <Field name="answer3" component={Input} color="#ffad42" />
              <Field name="answer4" component={Input} color="#97d574" />
              <Field name="answer5" component={Input} color="#2dd641" />
            </div>
          </AnswerContainer>
        </Container>
      )}
    />
  );
};

const Container = styled.div`
  display: grid;
  grid-template-columns: 45% 55%;
`;
const PromptContainer = styled.div`
  border-right: 1px solid #edeffe;
`;
const AnswerContainer = styled.div`
  margin: 0 2em 2em 2em;
`;

const AddedPrompt = styled.div<{ isHover: boolean }>`
  display: grid;
  grid-template-columns: 90% 10%;
  align-items: center;
  background-color: ${(props) => (props.isHover ? "#eaedf0" : "#e3e7ea")};
  width: 17.5em;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 10px;
  margin-bottom: 1em;
  ${TitleText} {
    padding: 0.5em;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
